import type { FaireProductEntity } from "../../entity_types/product";

export const p_772gm3dxn7: FaireProductEntity = {
  token: "p_772gm3dxn7",
  type: "product",
  name: "IMANI PAISLEY MIDI DRESS",
  brandToken: "b_7dohhmz00v",
  brandName: "Pretty Garbage",
  imageUrl:
    "https://cdn.faire.com/fastly/2d6dac8de29747a2c3bc00a3c54fdc744656ab9efd8eb4a970523ad16e6a576d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8723c1dc87676d1fc9736861f6263b4beffb159d67123287e6a2ef9686ccd425.jpeg",
    "https://cdn.faire.com/fastly/2a423807ce6d0c20f220a76f7d7fc57863fc822e9c13d624168ac42fc3c9564e.jpeg",
    "https://cdn.faire.com/fastly/b4fd9f4d499be4562ca157f660ddad3b7b017ea82c19a247d561dd60164bd7b1.jpeg",
    "https://cdn.faire.com/fastly/4c24060bf5b5f8f76daa1cc71fcc3373f03173f976ee372168c1915b96af6923.jpeg",
    "https://cdn.faire.com/fastly/769fe8f272c14ea8e86a633f36f2265f120c4600785daf6d471f817321af0e71.jpeg",
  ],
  priceDollars: 144,
  description:
    "The Imani Paisley Midi Dress pairs a fluid paisley design with a sleek, body-skimming silhouette that’s easy to dress up or down. Slim spaghetti straps and a front tie detail keep the neckline delicate and feminine while adding a touch of shape.\n\nDesign: Midi dress in an allover paisley pattern featuring slender spaghetti straps and a tie detail at the front that draws the eye and adds subtle definition. Fully lined for smooth coverage and a more polished drape.\n\nFit: Fitted through the bodice with gentle stretch that follows your curves, falling to a midi length for an elongating, versatile look.\n\nMaterials: Soft, stretchy woven blend designed for comfortable, all-day wear. Fabric: self 92% polyester, 8% spandex; lining 100% polyester.\n\nModel is 5'8\" and wearing a size small.",
  tags: [],
  msrpDollars: 288,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:01.101Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
